// SubscriptionService.js — API layer for the Subscription & Billing module
import apiRequest from './apiService';

const SUBS = '/subscriptions';

// ---------------- Client portal + super admin (master-scoped) ----------------
export const getMySubscription = async () => {
    return apiRequest(`${SUBS}/getMySubscription`, 'POST', {});
};

export const getSubscriptionUploadUrl = async (fileName, fileType, prefix) => {
    return apiRequest(`${SUBS}/getUploadUrl`, 'POST', { fileName, fileType, prefix });
};

export const getAdminUploadUrl = async (fileName, fileType, prefix) => {
    return apiRequest(`${SUBS}/getAdminUploadUrl`, 'POST', { fileName, fileType, prefix });
};

export const submitSubscriptionPayment = async (payload) => {
    return apiRequest(`${SUBS}/submitPayment`, 'POST', payload);
};

export const getSubscriptionInvoices = async (masterId) => {
    return apiRequest(`${SUBS}/getInvoices`, 'POST', masterId ? { masterId } : {});
};

export const getSubscriptionInvoiceById = async (invoiceId) => {
    return apiRequest(`${SUBS}/getInvoiceById`, 'POST', { invoiceId });
};

// ---------------- Super admin only ----------------
export const getSubscriptionSettings = async () => {
    return apiRequest(`${SUBS}/getSettings`, 'POST', {});
};

export const updateSubscriptionSettings = async (settings) => {
    return apiRequest(`${SUBS}/updateSettings`, 'POST', settings);
};

export const getAllSubscriptions = async () => {
    return apiRequest(`${SUBS}/getAllSubscriptions`, 'POST', {});
};

export const saveSubscription = async (payload) => {
    return apiRequest(`${SUBS}/saveSubscription`, 'POST', payload);
};

export const generateSubscriptionInvoice = async (payload) => {
    return apiRequest(`${SUBS}/generateInvoice`, 'POST', payload);
};

export const getAllSubscriptionInvoices = async (masterId) => {
    return apiRequest(`${SUBS}/getAllInvoices`, 'POST', masterId ? { masterId } : {});
};

export const getPaymentRequests = async (status = 'pending', masterId) => {
    return apiRequest(`${SUBS}/getPaymentRequests`, 'POST', { status, masterId });
};

export const reviewSubscriptionPayment = async (payload) => {
    return apiRequest(`${SUBS}/reviewPayment`, 'POST', payload);
};
